module.exports = __webpack_public_path__ + "static/autowrite_js-5ff204de3d50bce739039a030294d1ce.png";